export { GlobalStyles } from './GlobalStyles';
